const _ = require('lodash');
const SetStoreMapper = require('../shoplocator/atm/set-store-mapper');

module.exports = function (StorePickerPanelService, StorePickerService, globalHeaderPanelService, geolocation, bwsNotificationService, $state, atm, deliveryService, shopLocatorService, googleMapsApi, BreakpointsService, settingsService) {
    return {
        restrict: 'E',
        scope: {
        },
        link(scope) {
            scope.storePicker = StorePickerService;
            scope.storePickerPanelService = StorePickerPanelService;
            scope.globalHeaderPanelService = globalHeaderPanelService;
            scope.deliveryWindowsLoading = false;
            scope.storeLocation = StorePickerPanelService.deliverySearch;
            scope.deliveryService = deliveryService;
            scope.isEnabledDeliveryGuarantee = false;
            scope.deliveryGuaranteeNewMessageFeatureFlag = false;
            scope.deliveryGuaranteeOnTimeText = '';
            scope.deliveryGuaranteeBusyText = '';
            scope.deliveryGuaranteeOrNextFreeText = '';

            settingsService.getSettingValue('DeliveryGuarantee', 'EnableDeliveryGuarantee').then(function (setting) {
                scope.isEnabledDeliveryGuarantee = setting || false;
            });

            settingsService.getSettingValue('MobileApp', 'EnableDeliveryGuaranteeFeature').then((value) => {
                scope.deliveryGuaranteeNewMessageFeatureFlag = value || false;
            });
            settingsService.getSettingValue('MobileApp', 'BestGuessMessageText').then(function (msg) { scope.deliveryGuaranteeOrNextFreeText = msg; });
            settingsService.getSettingValue('MobileApp', 'DeliveryGuaranteeOnTimeText').then(function (msg) { scope.deliveryGuaranteeOnTimeText = msg; });
            settingsService.getSettingValue('MobileApp', 'DeliveryGuaranteeBusyText').then(function (msg) { scope.deliveryGuaranteeBusyText = msg; });

            scope.openDeliveryTnC = function () {
                window.open('https://bws.com.au/help/delivery-guarantee');
            };
            scope.openTnC = function () {
                window.open('https://bws.com.au/help/terms-and-conditions');
            };
            scope.showStoreList = function () {
                StorePickerPanelService.changeStoreView = true;
            };

            scope.storePickerPanelService.onPanelClosed = function () {
                if (scope.storePicker.fulfilmentInfo.IsSystemAddress && !BreakpointsService.isSmallFormat()) {
                    bwsNotificationService.info('Set your store to view pricing, promotions and product availability in your local BWS');
                }
            };

            scope.$watch('storePicker.fulfilmentInfo.IsSystemAddress', function (val, oldVal) {
                if (val && val !== oldVal && $state.previous.route.name !== 'checkout' && $state.previous.route.name !== 'checkout.checkoutLogin' && !$state.includes('shop.authentication.signup')) {

                    //If user allows geolocation open the store picker panel
                    if (geolocation && geolocation.getCurrentPosition !== undefined) {
                        scope.searchingStoresNearYou = true;
                        // Clear the delivery suburb info, before we call api for suburb near current location.
                        StorePickerPanelService.deliverySearch = {};

                        geolocation.getCurrentPosition(
                            function (position) {

                                shopLocatorService.listSupermarkets({
                                    Max: 30,
                                    Latitude: position.coords.latitude,
                                    Longitude: position.coords.longitude
                                }).then(function (locations) {
                                    StorePickerPanelService.showStorePrompt = false;

                                    //Set click and collect store
                                    scope.storePicker.setPickupByStoreNo(locations.Stores[0].StoreNo).then(function () {
                                        bwsNotificationService.success(`You\'re browsing <strong>BWS ${locations.Stores[0].Name}</strong>.`);

                                        const fulfilmentInfo = scope.storePicker.fulfilmentInfo;

                                        const atmData = {
                                            event: 'BWSAUupdateStorePreferenceLocationShared',
                                            store: {
                                                StoreNo: fulfilmentInfo.DeliveryDetails.FulfilmentStoreID,
                                                Postcode: fulfilmentInfo.DeliveryDetails.StoreAddressPostalCode,
                                                Name: fulfilmentInfo.DeliveryDetails.FulfilmentStoreName
                                            },
                                            fulfilmentInfo
                                        };

                                        atm.push(atmData, SetStoreMapper);


                                        $state.forceReload();
                                    });

                                    if (locations.DeliveryStores.length) {

                                        googleMapsApi().then(function (google) {
                                            const geocoder = new google.maps.Geocoder;
                                            const location = { lat: position.coords.latitude, lng: position.coords.longitude };

                                            geocoder.geocode({ location }, function (results, status) {
                                                if (status === 'OK') {

                                                    let postcode, suburb;

                                                    if (results[0]) {
                                                        _.filter(results[0].address_components, function (obj) {
                                                            if (obj.types[0] === 'postal_code') {
                                                                postcode = obj.long_name;
                                                            }
                                                            if (obj.types[0] === 'locality') {
                                                                suburb = obj.long_name;
                                                            }

                                                        });

                                                        StorePickerPanelService.deliverySearch = {
                                                            FulfilmentStoreID: locations.DeliveryStores[0].StoreNo,
                                                            SuburbName: suburb,
                                                            PostCode: postcode
                                                        };

                                                        StorePickerPanelService.setSuburbInLocalStorage(StorePickerPanelService.deliverySearch);

                                                    } else {
                                                        console.log('No results found');
                                                    }

                                                } else {
                                                    console.log('Geocoder failed due to: ' + status);
                                                }
                                            });
                                        });
                                    }
                                });
                            }, function () {
                                scope.openStorePicker();
                            });
                    }
                }
            }, true);

            scope.openStorePicker = function () {
                StorePickerPanelService.open();

                if (StorePickerService.fulfilmentInfo.IsSystemAddress || StorePickerService.fulfilmentMethod === 'Delivery') {
                    StorePickerPanelService.changeStoreView = true;
                }
                StorePickerPanelService.showStorePrompt = StorePickerService.fulfilmentInfo.IsSystemAddress ? true : false;
                
                scope.globalHeaderPanelService.closePanel();

            };

            function getDeliveryWindows() {

                scope.deliveryWindowsLoading = true;

                if (scope.storePicker.fulfilmentInfo.FulfilmentMethod === 'Delivery') {

                    scope.storeLocation = StorePickerPanelService.deliverySearch;

                    deliveryService.getDeliveryWindows({
                        Postcode: StorePickerPanelService.deliverySearch.PostCode,
                        Suburb: StorePickerPanelService.deliverySearch.SuburbName,
                        State: StorePickerPanelService.deliverySearch.State
                    }).then(function () {

                        if (deliveryService.hideAsapOption) {
                            scope.dateToday = new Date();
                            scope.dateTomorrow = new Date();
                            scope.dateTomorrow.setDate(scope.dateToday.getDate() + 1);

                            scope.nextWindowDateText = null;
                            scope.nextWindowDayText = null;

                            if (deliveryService.timeTable.length) {

                                const nextDeliveryDate = new Date(deliveryService.timeTable[0].WindowDate).getDate();

                                scope.firstAvailableWindow = {
                                    windowTime: deliveryService.timeTable[0].WindowTimings[0],
                                    windowRange: deliveryService.timeTable[0].WindowRanges[0]
                                };
                                if (nextDeliveryDate === scope.dateToday.getDate()) {
                                    scope.nextWindowDateText = 'today';
                                } else if (nextDeliveryDate === scope.dateTomorrow.getDate()) {
                                    scope.nextWindowDateText = 'tomorrow';
                                } else {
                                    scope.nextWindowDayText = deliveryService.timeTable[0].WindowDate;
                                }
                            }
                        }
                    }).finally(function () {
                        scope.deliveryWindowsLoading = false;
                    });
                }

            }

            scope.$watch('storePicker.store.FulfilmentStoreID', function (newVal, oldVal) {
                if (!(_.isUndefined(newVal) && _.isUndefined(oldVal))) {
                    shopLocatorService.getStore(newVal).then(function (storeInformation) {
                        shopLocatorService.setSelectedStoreState(storeInformation.State);
                    });

                    getDeliveryWindows();
                }

            }, true);

        },
        template: require('./store-picker-template.html').trim()
    };
};


/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/storepicker/store-picker-directive.js
 **/